/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_Group_ContentInputs */

const en_reading_labels_group_content = /** @type {(inputs: Reading_Labels_Group_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const es_reading_labels_group_content = /** @type {(inputs: Reading_Labels_Group_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Reading_Labels_Group_ContentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_group_content = /** @type {((inputs?: Reading_Labels_Group_ContentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_Group_ContentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_group_content(inputs)
	return en_reading_labels_group_content(inputs)
});